module.exports = __webpack_public_path__ + "static/media/icon-forward.d74018d1.svg";